import MainInfoCell from "./MainInfoCell";
import React, {useCallback, useEffect, useState} from "react";
import FeaturesButton from "./FeaturesButton";
import {JsonRenderer} from "../JsonRenderer";
import {isMobile} from "../../App";
import ScrollToTopButton from "../ScrollToTopButton";
import Gap from "../Gap";
import {useParams} from "react-router-dom";
import useSiteData from "../../hooks/useSiteData";

export default function Remastered() {
    const {server} = useParams()
    const [button, setButton] = useState(window.location.hash.split('#')[1] ?? 'features')
    const {siteData} = useSiteData(server, localStorage.getItem('lang'), true);

    useEffect(() => {
        if (!isMobile) {
            if (window.location.hash.length) {
                scrollToSection()
            }
        }
    }, [server, siteData]);

    const changeTab = useCallback((id) => {
        setButton(id)
        window.location.hash = `#${id}`
        if (!isMobile) {
            scrollToSection()
        }
    }, [])

    useEffect(() => {
        const handleHashChange = () => {
            if (button !== window.location.hash.split('#')[1]) {
                changeTab(window.location.hash.split('#')[1])
            }
        }

        window.addEventListener('hashchange', handleHashChange);

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [button, changeTab]);


    const scrollToSection = () => {
        const headerHeight = 200;
        const element = document.querySelector('#w_button_features_features');
        if (!element) return;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
            top: elementPosition - headerHeight,
            behavior: 'smooth'
        });
    }

    return (
        <>
            {siteData && (
                <>
                    <div style={{display: "flex", gap: 8, flexWrap: 'wrap'}}>
                        {siteData.rates.map((item, index) => (
                            <MainInfoCell key={index} name={item.name} value={item.value}/>
                        ))}
                    </div>
                    <Gap/>
                    <div className="row align-items-top" style={{backgroundColor: 'rgba(14, 14, 14, .9)'}}>
                        <div className="col-lg-2">
                            {Object.keys(siteData.tabs).map((item, i) => (
                                <FeaturesButton
                                    key={i}
                                    matomo_id={`w_button_features_${item}`}
                                    active={button === item}
                                    onClick={() => changeTab(item)}
                                    name={item}
                                    text={siteData.tabs[item].buttonName}
                                />
                            ))}
                        </div>

                        <div className="col-lg-10">
                            <div className="row">
                                <div className="col-lg-12" style={{marginTop: 16}}>
                                    <div className="bg-dark-2" style={{
                                        marginBottom: 16,
                                        padding: 20,
                                        display: "flex",
                                        alignItems: 'flex-start',
                                        flexDirection: 'column'
                                    }}>
                                        <h4>{siteData.tabs[button].title}</h4>
                                        <JsonRenderer data={siteData.tabs[button].info}/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ScrollToTopButton/>
                    </div>
                </>
            )}
        </>
    )
}